import { useState } from "react";
import { createRecipe } from "../api";

type Props = { onSpawned: (jobId: string, targetId: string) => void };

export function RecipeCreator({ onSpawned }: Props) {
  const [prompt, setPrompt] = useState(
    "Build a rebalance recipe: use scenario.stub then optimizer.mean_variance with risk_aversion 1.0.",
  );
  const [targetId, setTargetId] = useState("recipes.my_recipe");
  const [targetVersion, setTargetVersion] = useState("1.0.0");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    setError(null);
    setBusy(true);
    try {
      const { job_id } = await createRecipe({
        prompt,
        target_id: targetId,
        target_version: targetVersion,
      });
      onSpawned(job_id, targetId);
    } catch (e) {
      setError(String(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card">
      <div className="row">
        <div>
          <label>target id</label>
          <input
            type="text"
            value={targetId}
            onChange={(e) => setTargetId(e.target.value)}
            placeholder="recipes.my_recipe"
          />
        </div>
        <div>
          <label>target version</label>
          <input
            type="text"
            value={targetVersion}
            onChange={(e) => setTargetVersion(e.target.value)}
            placeholder="1.0.0"
          />
        </div>
      </div>
      <div style={{ marginTop: 12 }}>
        <label>prompt</label>
        <textarea value={prompt} onChange={(e) => setPrompt(e.target.value)} />
      </div>
      {error && <div className="status-error" style={{ marginTop: 8 }}>{error}</div>}
      <div style={{ marginTop: 12 }}>
        <button disabled={busy || !prompt.trim() || !targetId.trim()} onClick={submit}>
          {busy ? "Spawning…" : "Create recipe"}
        </button>
      </div>
    </div>
  );
}
